import { useEffect, useState } from 'react'

import { subscibeTo } from 'app/common/data-box-store'

import Mailing, { Props as MailingProps } from './mailing'

type Props = {
  visibleFromBox: string
  defaultVisible?: boolean
} & MailingProps

const MailingBox = ({ visibleFromBox, defaultVisible = false, ...others }: Props) => {
  const [filterVisibility, setFilterVisibility] = useState(false)

  useEffect(() => {
    const unsubsribe = subscibeTo<boolean>(visibleFromBox, setFilterVisibility)
    return unsubsribe
  }, [visibleFromBox])

  useEffect(() => {
    setFilterVisibility(defaultVisible)
  }, [defaultVisible])

  if (filterVisibility) {
    return <Mailing {...others} />
  }

  return null
}

export default MailingBox
